import { render, staticRenderFns } from "./ThirdPartyPortalsDropDownList.vue?vue&type=template&id=aa80cd26"
import script from "./ThirdPartyPortalsDropDownList.vue?vue&type=script&lang=js"
export * from "./ThirdPartyPortalsDropDownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports